import { useRef, useState } from "react"
import "./ChoosePlan.less"
import Image from "../Common/Image/Image"

export const Accordion = ({ item,isActive,toggleAccordion }) => {

  const contentRef = useRef(null)

  return (
    <div className={`ChoosePlan_accordion`} onClick={() => toggleAccordion(item.key)}>
      <div className={`ChoosePlan_accordionTitle ${isActive && `accordionActive`}`}>
        <span className="ChoosePlan_position">{item.key}</span>
        <h3 className={`ChoosePlan_questionTitle ${isActive && `questionActiveTitle`}`}>{item.title}</h3>
        <Image src={`assets/${isActive ? "Expand_white" : "Expand_red"}.svg`} className={`ChoosePlan_expandIcon ${isActive && `activeExpand`}`}  alt="right_arrow_image" />
      </div>
      <div
        ref={contentRef}
        className={`ChoosePlan_accordionContent`}
        style={{ height: isActive && contentRef.current ? `${contentRef.current.scrollHeight}px` : "0px" , transition : "height 0.5s ease"}}
      >
        <span dangerouslySetInnerHTML={{ __html: item.content }}></span>
      </div>
    </div>
  )
}
